import { useState } from "react";
import {
  useExpanded,
  useFilters,
  useGlobalFilter,
  useSortBy,
  useTable,
} from "react-table";
import { Table } from "reactstrap";
import no_data_image from "../../../assets/images/table_empty_image.png";

const TableContainer = ({
  columns, data, className, isSorted, isSortedDesc, handleSort, setSortedDesc, setSorted
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows, // Use rows instead of page
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: "" },
      initialState: {
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded // Removed usePagination
  );

  const [id, setID] = useState("");

  const generateSortingIndicator = column => {
    return isSorted ? (isSortedDesc ? <i className="ri-arrow-down-s-fill p-2"></i> : <i className="ri-arrow-up-s-fill p-2"></i>) : <i className="ri-expand-up-down-fill p-2"></i>;
  };

  return (
    <div className="table-responsive react-table" style={{ backgroundColor: 'white' }}>
      <Table hover {...getTableProps()} className={className}>
        <thead className="table-light table-nowrap">
          {headerGroups.map((headerGroup, idx) => (
            <tr key={idx} style={{ fontFamily: 'Manrope-Bold', position: 'relative' }}>
              {headerGroup.headers.map((column, idx) => (
                <th
                  key={idx}
                  style={
                    column?.position === 'sticky' ? { minWidth: "12px" || 0, position: 'sticky', right: 0, zIndex: 1, backgroundColor: '#F9F9F9' } :
                      { minWidth: column?.minWidth || 0, backgroundColor: '#F9F9F9' }
                  }
                >
                  <div style={{ color: '#505D69', cursor: "pointer", }} onClick={(e) => (handleSort(column?.columnID), setSorted(true), setSortedDesc(!isSortedDesc), setID(idx))}>
                    {column.render("Header")}
                    {columns[idx]?.columnID ? id === idx ? generateSortingIndicator(column) : <i className="ri-expand-up-down-fill p-2"></i> : ""}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {data?.length > 0 &&
          <tbody {...getTableBodyProps()}>
            {rows.map((row, idx) => { // Use rows instead of page
              prepareRow(row);
              return (
                <tr key={idx} style={{ backgroundColor: 'white' }}>
                  {row.cells.map((cell, idx) => (
                    <td key={idx} style={
                      cell.column.Header === 'Action' ?
                        { color: '#505D69', position: 'sticky', right: 0, zIndex: 1, backgroundColor: 'white', width: "10px" } :
                        { color: '#505D69', backgroundColor: 'white' }
                    }>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        }
      </Table>
      {

        data?.length <= 0 &&
        <>
          <div className="d-flex justify-content-center w-100 pb-2" key={'no record-1'}>
            <img src={no_data_image} alt="empty-data" style={{ height: 120, width: 120 }} />
          </div>
          <div className="d-flex justify-content-center w-100 pb-2" key={'no record-2'} style={{ marginBottom: 10, color: '#999999' }}>
            No gift added
          </div>
        </>
      }
    </div>
  );
};

export default TableContainer;
